
import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import image from '../../images/bannerImages/img1.jpg'
import IntroVideos from "../../componants/introvideos";

import unlckmaretsecretimages from '../../images/cardpageimages/advanced/unlockmarketsecretimage.jpg'
import UnlockingMarketSecretsModule from "../../componants/allCourseModule/advancedCourseModule/UnlockingMarketSecretModule";
function UnlockingMarketSecret() {

  return (<>
    <Header />
    <BannerForAll
      text="Our Unlocking Market Secrets course is designed to reveal the hidden strategies and insights that can lead to successful trading. You’ll explore key concepts in market analysis, technical indicators, and trading psychology that professionals use to gain an edge. This course focuses on practical applications and real-world examples, helping you develop the skills to navigate market complexities confidently. Ideal for traders of all levels, this course aims to empower you to uncover market opportunities and enhance your trading results."
      title="UNLOCKING MARKET SECRETS"
      imageone={unlckmaretsecretimages}
      imagetwo={unlckmaretsecretimages}
    />
    <IntroVideos
      vone=""
      vtwo=""
      topic=""
    />
    <UnlockingMarketSecretsModule />
    <Footer />
  </>)
}

export default UnlockingMarketSecret;